module.exports = __webpack_public_path__ + "Channels.857ee641033944456e9b46cc27f2605a.hashedasset.svg";